import React, { Component } from "react";

import { Helmet } from "react-helmet";

import InformationItem from "components/InformationItem/Information-Item";
import TextBlock from "components/TextBlock/TextBlock";

import Hero from "components/PageHero/Hero";
import { I18n } from "react-i18next";

//content
import costaRica from "assets/images/Sustainable/FPG_duurzaamheid_01_header.jpg";
import people from "assets/images/Sustainable/FPG_duurzaamheid_02_people.jpg";
import planet from "assets/images/Sustainable/FPG_duurzaamheid_03_planet.jpg";
import profit from "assets/images/Sustainable/FPG_duurzaamheid_04.jpg";
import development from "assets/images/Sustainable/FPG_duurzaamheid_05_continu-ontwikkelen.jpg";
import integrated from "assets/images/Sustainable/FPG_duurzaamheid_06_onderdeel_worden.jpg";

export default class Innovation extends Component {
  render() {
    return [
      <I18n>
        {(t, { i18n }) => (
          <Helmet key="head">
            <meta charSet="utf-8" />
            <title>
              Innovatie | Forever Plants | Ontdek waar FPG voor staat
            </title>
            <meta
              property="og:image"
              content={`${process.env.REACT_APP_SAFE_URL}${costaRica}`}
            />
            <meta
              name="description"
              content="We vertellen graag over onszelf. Nog liever vertellen we over waar Forever Plants Group voor staat en wat we willen bereiken met de planten die we grootbrengen. Lees hier alles over het groener maken van woonkamers, bedrijven, levens en uiteindelijk ook de hele wereld. Ambitieus? Zeker. Onmogelijk? Niet als jij ook meehelpt."
            />
            <meta
              property="og:description"
              content="We vertellen graag over onszelf. Nog liever vertellen we over waar Forever Plants Group voor staat en wat we willen bereiken met de planten die we grootbrengen. Lees hier alles over het groener maken van woonkamers, bedrijven, levens en uiteindelijk ook de hele wereld. Ambitieus? Zeker. Onmogelijk? Niet als jij ook meehelpt."
            />
          </Helmet>
        )}
      </I18n>,
      <I18n>
        {(t, { i18n }) => (
          <main id="pageWrapper" key="content">
            <div className="wrapper-hero-video">
              <Hero imageSrc={costaRica} />
              <div className="wrapper">
                <TextBlock
                  extraClasses="text-education"
                  title={t("sustainableHeroTitle")}
                >
                  {t("sustainableHeroIntro")}
                </TextBlock>
              </div>
            </div>
            <div className="wrapper">
              <section id="more-about-us" className="">
                <InformationItem
                  informationMedia="wrapper-hero-video informationMedia informationMedia-video"
                  pictureURL={people}
                  informationContent="informationContent informationContent--Innovation"
                  h3className="informationTitle mb0"
                  pClassName="informationParagraph"
                  Title={t("sustainablePeopleTitle")}
                >
                  {t("sustainablePeoplePara")}
                </InformationItem>
                <InformationItem
                  informationMedia="wrapper-hero-video informationMedia order2 informationMedia-video"
                  pictureURL={planet}
                  informationContent="informationContent informationContent--Innovation"
                  h3className="informationTitle mb0"
                  pClassName="informationParagraph"
                  Title={t("sustainablePlanetTitle")}
                >
                  {t("sustainablePlanetPara")}
                </InformationItem>
                <InformationItem
                  informationMedia="wrapper-hero-video informationMedia  informationMedia-video"
                  pictureURL={profit}
                  informationContent="informationContent informationContent--Innovation"
                  h3className="informationTitle mb0"
                  pClassName="informationParagraph"
                  Title={t("sustainableProfitTitle")}
                >
                  {t("sustainableProfitPara")}
                </InformationItem>
                <InformationItem
                  informationMedia="wrapper-hero-video informationMedia order2 informationMedia-video"
                  pictureURL={development}
                  informationContent="informationContent informationContent--Innovation"
                  h3className="informationTitle mb0"
                  pClassName="informationParagraph"
                  Title={t("sustainableDevTitle")}
                >
                  {t("sustainableDevPara")}
                </InformationItem>
                <InformationItem
                  informationMedia="wrapper-hero-video informationMedia informationMedia-video"
                  pictureURL={integrated}
                  informationContent="informationContent informationContent--Innovation"
                  h3className="informationTitle mb0"
                  pClassName="informationParagraph"
                  Title={t("sustainableIntegratedTitle")}
                >
                  {t("sustainableIntegratedPara")}
                </InformationItem>
              </section>
            </div>
          </main>
        )}
      </I18n>,
    ];
  }
}



// WEBPACK FOOTER //
// ./src/Pages/Sustainable.jsx